import {
    FETCH_MENU,
    SAVE_MENU_CATEGORY,
    DELETE_MENU_CATEGORY,
    SAVE_MENU_ITEM,
    DELETE_MENU_ITEM,
    FETCH_RESTAURANT_MENU_TRANSLATIONS,
    UPDATE_MENU_EDIT_INFO,
    PREPARE_MENU,
} from '../../actions/types';

const INITIAL_STATE = {
    categories: {},
    items: {},
    editInfo: {},
    translationDictionary: {},
    preparedMenu: {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_MENU:
            return { ...state, ...action.payload };
        case PREPARE_MENU:
            return { ...state, preparedMenu: action.payload };
        case UPDATE_MENU_EDIT_INFO:
            return { ...state, editInfo: { ...state.editInfo, ...action.payload.editInfo } };
        case SAVE_MENU_CATEGORY:
            if (action.meta && action.meta.categoryId) {
                return {
                    ...state,
                    categories: {
                        ...state.categories,
                        [action.meta.categoryId]: { ...state.categories[action.meta.categoryId], ...action.payload }
                    }
                };
            }
            return {
                ...state,
                categories: {
                    ...state.categories,
                    [action.payload.id]: { ...action.payload }
                }
            };
        case DELETE_MENU_CATEGORY:
            return {
                ...state,
                categories: Object.keys(state.categories).reduce((categories, categoryId) => {
                    if (categoryId !== action.meta.categoryId) {
                        categories[categoryId] = { ...state.categories[categoryId] };
                    }
                    return categories;
                }, {})
            };
        case SAVE_MENU_ITEM:
            if (action.meta && action.meta.itemId) {
                return {
                    ...state,
                    items: {
                        ...state.items,
                        [action.meta.itemId]: { ...state.items[action.meta.itemId], ...action.payload }
                    }
                };
            }
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.payload.id]: { ...action.payload }
                }
            };
        case DELETE_MENU_ITEM:
            return {
                ...state,
                items: Object.keys(state.items).reduce((items, itemId) => {
                    if (itemId !== action.meta.itemId) {
                        items[itemId] = { ...state.items[itemId] };
                    }
                    return items;
                }, {}),
                categories: {
                    ...state.categories,
                    ...Object.values(state.categories).reduce((categories, category) => {
                        const itemsInstances = category.itemsInstances.filter(i => i.itemId !== action.meta.itemId);
                        if (itemsInstances.length !== category.itemsInstances.length) {
                            categories[category.id] = { ...category, itemsInstances };
                        }
                        return categories;
                    }, {}),
                }
            };
        case FETCH_RESTAURANT_MENU_TRANSLATIONS:
            return { ...state, translationDictionary: action.payload };
        default:
            return state;
    }
};

